export const HOW_IT_WORKS_ICONS = {
  step1: 'https://cdn.naviparking.com/digital_parking/landing/duotone.svg',
  step2: 'https://cdn.naviparking.com/digital_parking/how_it_works/step2.svg',
  step3: 'https://cdn.naviparking.com/digital_parking/how_it_works/step3.svg',
  step4: 'https://cdn.naviparking.com/digital_parking/how_it_works/step4.svg',
  step5: 'https://cdn.naviparking.com/digital_parking/how_it_works/step5.svg',
  line: 'https://cdn.naviparking.com/digital_parking/how_it_works/line.svg'
} as const

export type StepIconKey = keyof typeof HOW_IT_WORKS_ICONS
